var buildScriptTag = function (src, attrs) {
    if (typeof document === 'undefined')
        return;
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = src;
    for (var _i = 0, _a = Object.keys(attrs); _i < _a.length; _i++) {
        var attr = _a[_i];
        script.setAttribute(attr, attrs[attr]);
    }
    return script;
};
/**
 * 异步加载script
 */
export default (function (url, attrs) {
    if (attrs === void 0) { attrs = {}; }
    var script = buildScriptTag(url, attrs);
    var p = new Promise(function (resolve, reject) {
        script.onload = function () {
            resolve();
        };
        script.onerror = function () {
            reject();
        };
    });
    document.body.appendChild(script);
    return p;
});
//# sourceMappingURL=load-script.js.map